/*
 app dependencies
 - var body

 lib dependencies
*/

const scCommentForm = (function()
{
    const   _mainFormToggle = document.querySelector('.js-add-comment-main-btn'),
            _formToggles = document.querySelectorAll('.js-add-comment'),
            _commentsList = document.querySelector('.js-comments-list');

    let     _formLoaded = false,
            _formLoading = false,
            _formVisible = false,
            _form,
            _inputParentComment,
            _respondTo,
            _cancelResponse;

	//module functions
	function init()
	{
        if (!_mainFormToggle) return;

        for (const toggle of _formToggles)
        {
            toggle.addEventListener('click', function(e)
            {
                e.preventDefault();

                //login check
                if (!scState.isLoggedIn)
                {
                    scUi.loginPopup('<p>Om een reactie te plaatsen moet u inloggen.</p>');
                    return;
                }


                if (!_formVisible)
                {
                    //this sets variables, run first!
                    _initForm();

                    //hide main btn
                    _mainFormToggle.classList.add('hide');

                    //show form
                    _form.classList.add('comment-form--visible');
                    _formVisible = true;
                }

                _setParentCommentIdByToggle(this);
                scrollTo(_form);

                /*if (_formLoaded)
                {
                    _setParentCommentIdByToggle(this);
                    scrollTo(_form);
                }
                else if (!_formLoading)
                {
                    _formLoading = true;
                    _loadCommentForm(this);
                }*/
            });
        }
	}

        function _loadCommentForm(toggle)
        {
            doAjax({
    			ajaxUrl: `/ajax/get-comment-form/${_mainFormToggle.dataset.factslug}/${_mainFormToggle.dataset.checkslug}`,
    			onSuccess: _onLoadFormSuccess,
    			onError: _onLoadFormError,
                params: {
                    toggle
                }
    		});
        }

            /*function _onLoadFormSuccess(rawResponse, params)
            {
                _formLoaded = true;
                _formLoading = false;

                try
                {
                    var response = $.parseJSON(rawResponse);

                    if (response.success)
                    {
                        //add form to dom
                        _mainFormToggle.insertAdjacentHTML('afterend', response.html);
                        _mainFormToggle.classList.add('hide');

                        _initForm();

                        //set parent comment id
                        _setParentCommentIdByToggle(params.toggle);

                        scrollTo(_form);

                    }
                    else throw new Error(response.message);
                }
                catch (err) { alert(err.message); }
            }*/

                function _initForm()
                {
                    //set references
                    _form = document.querySelector('.js-comment-form'),
                    _inputParentComment = document.querySelector('.js-comment-form-parent-id'),
                    _respondTo = document.querySelector('.js-comment-form-respond-to'),
                    _cancelResponse = document.querySelector('.js-comment-form-cancel-response');

                    //setup cancel response listener
                    _cancelResponse.addEventListener('click', function(e)
                    {
                        e.preventDefault();
                        _inputParentComment.value = 0;
                        _form.classList.remove('comment-form--responding');
                    });

                    //setup submit listener
                    _form.addEventListener('submit', function(e)
                    {
                        e.preventDefault();

                        if ($(this).validateForm())
                        {
                            doAjax({
                                ajaxUrl: this.getAttribute('action'),
                                data: $(this).serializeArray(),
                                onSuccess: _onAddCommentSuccess,
                                onError: _onAddCommentError,
                                params: {
                                    parentId: _inputParentComment.value
                                }
                            });
                        }
                    });
                }

                    function _onAddCommentSuccess(rawResponse, params)
                    {
                        try
                        {
                            var response = $.parseJSON(rawResponse);

                            if (response.success)
                            {
                                if (+response.parentCommentId !== 0)
                                {
                                    const parentCommentsList = document.querySelector(`.js-comments-list-${response.parentCommentId}`);
                                    parentCommentsList.insertAdjacentHTML('beforeend', `<li class="comment">${response.html}</li>`);
                                    scrollTo(parentCommentsList.querySelector('li:last-child'));
                                }
                                else
                                {
                                    _commentsList.insertAdjacentHTML('beforeend', `<li class="comment">${response.html}</li>`);
                                }


                                //reset
                                _form.reset();
                                _form.classList.remove('comment-form--responding');
                                _inputParentComment.value = 0;
                            }
                            else throw new Error(response.message);
                        }
                        catch (err) { alert(err.message); }
                    }


                    function _onAddCommentError(jqxhr, textStatus, errorThrown, params)
                    {
                        //error?
                        if (!userAbortedAjax(jqxhr)) alert(errorThrown);
                    }


            /*function _onLoadFormError(jqxhr, textStatus, errorThrown, params)
            {
                _formLoading = false;
                //error?
                if (!userAbortedAjax(jqxhr)) alert(errorThrown);
            }*/


        function _setParentCommentIdByToggle(toggle)
        {
            //respond to other comment?
            const parentCommentId = toggle.dataset.commentId;
            if (parentCommentId)
            {
                _inputParentComment.value = parentCommentId;
                _form.classList.add('comment-form--responding');
                _respondTo.textContent = document.querySelector(`.js-user-comment-${parentCommentId}`).textContent;
            }
            else
            {
                _inputParentComment.value = 0;
                _form.classList.remove('comment-form--responding');
            }
        }


    // function _initFormToggles()
    // {
    //     for (const toggle of _formToggles)
    //     {
    //         toggle.addEventListener('click', function(e)
    //         {
    //             e.preventDefault();
    //
    //             _form.classList.add('comment-form--visible');
    //             _mainFormToggle.classList.add('hide');
    //
    //             //respond to other comment?
    //             const parentCommentId = this.dataset.commentId;
    //             if (parentCommentId)
    //             {
    //                 _inputParentComment.value = parentCommentId;
    //                 _form.classList.add('comment-form--responding');
    //                 _respondTo.textContent = document.querySelector(`.js-user-comment-${parentCommentId}`).textContent;
    //             }
    //             else
    //             {
    //                 _inputParentComment.value = 0;
    //                 _form.classList.remove('comment-form--responding');
    //             }
    //         });
    //     }
    //
    //     _cancelResponse.addEventListener('click', function(e)
    //     {
    //         e.preventDefault();
    //         _inputParentComment.value = 0;
    //         _form.classList.remove('comment-form--responding');
    //     });
    // }

	//reveal public vars and functions
	return {
		//vars

		//functions
		init
	};

})();
